import React from "react";
import { getClassNameFactory } from "../../../../utilities/classNames/";
import Image from "../../../../elements/Image";

var FeaturedItem = function FeaturedItem(_ref) {
  var children = _ref.children,
      imageAnchor = _ref.imageAnchor,
      imageSrc = _ref.imageSrc,
      imageSrcSet = _ref.imageSrcSet;
  var getClassName = getClassNameFactory(FeaturedItem.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "image"
    })
  }, /*#__PURE__*/React.createElement(Image, {
    anchor: imageAnchor,
    alt: "",
    fit: "cover",
    height: 120,
    sizes: Image.sizes.oneThird,
    src: imageSrc,
    srcSet: imageSrcSet
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, children));
};

FeaturedItem.defaultProps = {
  imageAnchor: Image.AnchorTypes.C
};
FeaturedItem.displayName = "SiteHeader.FeaturedItem";
export default FeaturedItem;